import PropTypes from 'prop-types';
import compose from '../hoc/compose';
import template from './panelHeaderIllustration.jsx';
var PanelHeaderIllustration = template;
PanelHeaderIllustration.displayName = 'PanelHeaderIllustration';
PanelHeaderIllustration.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  blueStripHeight: PropTypes.number
};
PanelHeaderIllustration.defaultProps = {
  blueStripHeight: 90
};
export default compose(PanelHeaderIllustration);